__turbopack_context__.v({
  "actionButton": "styles-module-scss-module__RroQfW__actionButton",
  "center": "styles-module-scss-module__RroQfW__center",
  "closeButton": "styles-module-scss-module__RroQfW__closeButton",
  "error": "styles-module-scss-module__RroQfW__error",
  "flex-end": "styles-module-scss-module__RroQfW__flex-end",
  "flex-start": "styles-module-scss-module__RroQfW__flex-start",
  "fullScreenContainer": "styles-module-scss-module__RroQfW__fullScreenContainer",
  "iconVariant": "styles-module-scss-module__RroQfW__iconVariant",
  "info": "styles-module-scss-module__RroQfW__info",
  "message": "styles-module-scss-module__RroQfW__message",
  "messageLink": "styles-module-scss-module__RroQfW__messageLink",
  "messageLinkBlue": "styles-module-scss-module__RroQfW__messageLinkBlue",
  "messageSeparateLink": "styles-module-scss-module__RroQfW__messageSeparateLink",
  "messageText": "styles-module-scss-module__RroQfW__messageText",
  "messageTextWithButton": "styles-module-scss-module__RroQfW__messageTextWithButton",
  "messageTextWrapper": "styles-module-scss-module__RroQfW__messageTextWrapper",
  "space-between": "styles-module-scss-module__RroQfW__space-between",
  "success": "styles-module-scss-module__RroQfW__success",
  "variantIcon": "styles-module-scss-module__RroQfW__variantIcon",
  "warning": "styles-module-scss-module__RroQfW__warning",
});
